var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type==='1')?_c('default-index',{ref:"defaultIndex",attrs:{"pri_detail":{
                          activityObj:{bank_center_id:_vm.bank_center_id,province_id:_vm.province_id,city_id:_vm.city_id,county_id:_vm.county_id,station_id:_vm.station_id,di_uuid:_vm.di_uuid},
                       }}}):_vm._e(),_vm._v(" "),(_vm.type==='2')?_c('default-index1',{ref:"defaultIndex1",attrs:{"pri_detail":{
                          activityObj:{bank_center_id:_vm.bank_center_id,province_id:_vm.province_id,city_id:_vm.city_id,county_id:_vm.county_id,station_id:_vm.station_id,di_uuid:_vm.di_uuid},
                       }}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-939616f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LoginDevice.vue
// module id = null
// module chunks = 